<template>
  <div class="income">
      <SelectMonth @fMethod="getDate" :startData="startData" :endData="endData"></SelectMonth>
      <div id="userBlock" ref="chart"></div>
  </div>
</template>
<script>
import {url,operate} from '@/utils/config'
import {postFun} from '@/utils/httpFun'
import SelectMonth from './../a-module/block-selectMonthIcon.vue'
export default {
  components:{
      SelectMonth:SelectMonth,
  },
  props:{
    width:{
      type:Number,
      default:100
    }  
  },
  data: ()=>({
    startData:"",
    endData:"",
     parms:{
        endTime:"",
        startTime:"",
        timeType:1,    //1近七天 2近一个月 3近一年
     },
     myChart:{}
  }),
  computed: {
      refreshStr() {
         return this.$store.state.windowwidth || this.$store.state.windowwidth;
      }
   },
    watch: {
      refreshStr(val) {
        console.log('刷新======')
         if (val) {
            this.myChart.resize()
         }
      }
   },
  mounted() {
     this.getInfo()
  },
  methods:{
    
    //更新数据
    getDate(ev){
       this.parms.timeType = ev.type

       let isMark = ev.type==4 &&!!ev.endTime&&!!ev.startTime 
       if(isMark){

        this.startData =ev.startTime;
        this.endData =ev.endTime;

        this.parms.startTime =  ev.startTime+" 00:00:00" 
        this.parms.endTime =  ev.endTime+" 23:59:59"
        this.getInfo()
       }else{
          if(ev.type!=4){
            this.getInfo()
          }
       }
    },

    //获取的数据
    getInfo(){
        let xVal = []
        let xListValA = []
        postFun(operate.INCOMEMONEYZHU,this.parms,res=>{
            if(res.data.list.length==0){
                this.xVal = [0]
                this.xListValA = [0]
                this.init()
                return
            }
            let list = res.data.list
            this.startData = list[0].time
            this.endData = list[list.length-1].time
            list.forEach(element => {
                xVal.push(element.time)
                xListValA.push(element.incomeAmount)
            });
            console.log(xVal.length)
            this.xVal = xVal
            this.xListValA = xListValA

            let x = 28        
            let rote = 0   

            if(this.parms.timeType == 1){
                let date = new Date(this.xVal[this.xVal.length - 1]);

                let month = date.getMonth()+1;
                let day = date.getDate();

                x = 38;

                this.xVal[this.xVal.length - 1] = `${((month+'').length)  == 2?month:'0'+month}-${((day+'').length) == 2?day:'0'+day}`;
            }else if(this.parms.timeType == 2){

                console.log('======-1')

                for(let index in this.xVal){

                    console.log('=============测试',index)

                    let item = this.xVal[index];
                    let date = new Date(item);

                    let month = date.getMonth()+1;
                    let day = date.getDate();

                    console.log('============day',day,((day+'').length))

                    this.xVal[index] = `${((month+'').length) == 2?month:'0'+month}-${((day+'').length) == 2?day:'0'+day}`;
                }

                rote = -50;
            }else if(this.parms.timeType == 3){
                x = 50;
                rote = -0;
            }

            this.init(x,rote)

        })
      },
      
      init(x = 28,rote=0) {
            let myChart = this.$_echarts.init(document.getElementById('userBlock'))
            this.myChart = myChart
            var option = {
                title: {},
                tooltip: {
                    show:true,
                    trigger: 'axis',
                    position: function (pt) {
                        return [pt[0], '10%'];
                    }
                },
                legend: {
                    x: 'center',
                    y: 'bottom',
                    data: ['收入'],
                    itemGap: 30,
                    icon:"roundRect",
                    itemWidth: 16,
                    itemHeight: 10,
                    itemStyle: {
                        borderCap: 'round'
                    }
                },
                grid: { //方法 2
                    x: 10,
                    y: 10,
                    x2:x,
                    y2: 35,
                    containLabel: true
                },
                xAxis: {
                    data: this.xVal,
                    boundaryGap: false,
                    axisLine:{
                        show:false,
                    },
                    axisLabel:{
                        interval:"",
                        // showMaxLabel: true,
                        rotate:rote,
                        align:"left" 
                    },
                    axisTick: {
                        show:false,
                        alignWithLabel: true,
                    },
                    splitArea : {show : false}
                },
                yAxis: {
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed'
                        }
                    }
                },
                series: [
                    {
                        name: '收入',
                        type: 'line',
                        symbol: "none",
                        smooth:true,
                        sampling: 'average',
                        barWidth: 1,
                        data: this.xListValA,
                        itemStyle: {
                            color: "#FF9B44",
                        },
                        lineStyle: {
                            color: '#FF9B44',
                            width: 1
                        },
                        areaStyle: {
                            color: new this.$_echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgb(255,137,72,0.5)'
                            }, {
                                offset: 1,
                                color: 'rgb(235,246,254,0.1)'
                            }])
                        },
                    }
                ]
            }
            this.myChart.setOption(option);
        },
  },
}
</script>
<style lang="scss" scoped>
    .income{
        background: #FFFFFF;
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
    }
    #userBlock{
       width: 100%;
       height:220px;
       margin-top: 20px;
    }
</style>
